import {
  Cpu,
  Landmark,
  HeartPulse,
  GraduationCap,
  Building2,
  Factory,
  Award,
  Zap,
  Cog,
  CircleDollarSign,
  Headset,
  type LucideIcon,
} from 'lucide-react';

export interface Industry {
  id: string;
  name: string;
  icon: LucideIcon;
}

export interface WhyChooseItem {
  id: string;
  icon: LucideIcon;
  title: string;
  description: string;
}

export const industries: Industry[] = [
  {
    id: 'it',
    name: 'Information Technology',
    icon: Cpu,
  },
  {
    id: 'finance',
    name: 'Financial Services',
    icon: Landmark,
  },
  {
    id: 'healthcare',
    name: 'Healthcare & Pharmaceuticals',
    icon: HeartPulse,
  },
  {
    id: 'education',
    name: 'Education & Research',
    icon: GraduationCap,
  },
  {
    id: 'government',
    name: 'Government & Public Sector',
    icon: Building2,
  },
  {
    id: 'manufacturing',
    name: 'Manufacturing & Engineering',
    icon: Factory,
  },
];

export const whyChooseUs: WhyChooseItem[] = [
  {
    id: 'certified',
    icon: Award,
    title: 'Certified Excellence',
    description: 'Authorized partnerships with leading global technology brands',
  },
  {
    id: 'delivery',
    icon: Zap,
    title: 'Rapid Deployment',
    description: 'Industry-leading delivery times with reliable project execution',
  },
  {
    id: 'solutions',
    icon: Cog,
    title: 'Tailored Solutions',
    description: 'Custom-engineered systems designed for your specific requirements',
  },
  {
    id: 'pricing',
    icon: CircleDollarSign,
    title: 'Competitive Pricing',
    description: 'Transparent pricing models with flexible financing options',
  },
  {
    id: 'support',
    icon: Headset,
    title: 'Enterprise Support',
    description: 'Dedicated account management with 24/7 technical assistance',
  },
];
